var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoreCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_24043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 10H11C9.9 10 9 10.9 9 12V26C9 27.1 9.9 28 11 28H25C26.1 28 27 27.1 27 26V12C27 10.9 26.1 10 25 10ZM18 12H19.5V15L21.5 12H23.2L21.2 15L23.2 18H21.5L19.5 15V18H18V12ZM13 14.25H15.5V13.5H13V12H17V15.75H14.5V16.5H17V18H13V14.25ZM25 20L19 26L15 22L11 26V23.5L15 19.5L19 23.5L25 17.5V20Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_24043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreCheckin);
export default __webpack_public_path__ + "static/media/scoreCheckin.8cfe0e9233e8a685b76c93e5a02eb287.svg";
export { ForwardRef as ReactComponent };